import React from 'react';
import cn from 'classnames';
import { extConfig } from '../../../Editor/presets/AttachmentCaption/config';
import Viewer from '../../Viewer';
import s from './AttachmentCaption.scss';
const AttachmentCaptionViewer = /*#__PURE__*/ React.forwardRef(({ contentJson, className, externalRenderers, cookieType, defaultSize }, ref)=>{
    return /*#__PURE__*/ React.createElement(Viewer, {
        presetId: "attachment-caption",
        contentJson: contentJson,
        className: cn(s['root'], className),
        extensionConfig: extConfig,
        externalRenderers: externalRenderers,
        cookieType: cookieType,
        defaultSize: defaultSize,
        ref: ref
    });
});
AttachmentCaptionViewer.displayName = 'AttachmentCaptionViewer';
export default AttachmentCaptionViewer;

//# sourceMappingURL=AttachmentCaption.js.map